<template>
  <div class="case">
    <div class="wrap">
      <div class="title" v-if="this.$route.name === 'Home'">
        <h3>成功案例分享</h3>
        <span>客户案例 <img src="@/assets/images/icon1.png"></span>
      </div>
      <div class="case-tab">
        <div v-for="(item, index) in tabData" :key="index" :class="['tab-item', activeTab === index ? 'active' : '']" @click="onClickTab(item, index)">
          <span>{{ item.title }}</span>
        </div>
      </div>
      <div class="case-box">
        <div v-for="(item, index) in caseList" :key="index" class="case-item" v-show="activeTab == 0 || activeTab == item.type">
          <div class="pic">
            <img :src="item.img">
            <router-link 
              :to="{ 
                path: '/CaseDetails', 
                query: { id: item.id } 
              }"
            >
              查看详情
            </router-link>
          </div>
          <div class="case-title">
            <div class="case-text">
              <h3>{{item.title}}</h3>
              <p>{{item.describe}}</p>
            </div>
            <div class="case-link">
              <p>{{item.caseName}}</p>
              <img src="@/assets/images/arrow.png">
            </div>
          </div>
        </div>
      </div>
      <div class="case-more" v-if="this.$route.name === 'Home'">
        <router-link to="/Case">查看更多案例</router-link>
      </div>
    </div>
  </div>

</template>
  
  <script>

  export default {
    data() {
      return {
        activeTab: 0,
        tabData:[{title: 'ALL'}, {title: '网站建设'}, {title: 'app开发'}, {title: '视觉设计'}],
        caseList: [
          {img: require('@/assets/images/case12.png'), title: '洛克家居', describe: '一家生产高档实木家居、注重生活品质的生产商', caseName: '网站建设', type: 1, id: 1},
          {img: require('@/assets/images/case7.png'), title: '外贸商城', describe: '一家销售手机配件公司，商品热销欧美市场', caseName: '网站建设', type: 1, id: 2},
          {img: require('@/assets/images/case8.png'), title: '外贸网站', describe: '响应式外贸网站，多端自适应的品牌网站', caseName: '网站建设', type: 1, id: 3},
          {img: require('@/assets/images/case3.png'), title: '金融公司', describe: '金融公司量化投资品牌网站', caseName: '网站建设', type: 1, id: 4},
          {img: require('@/assets/images/case6.png'), title: '生鲜供应系统', describe: '一家供应早餐市场的B2B生鲜购物平台', caseName: 'APP开发', type: 2, id: 5},
          {img: require('@/assets/images/case9.png'), title: '心理咨询系统', describe: '一家专注青少年成长，心理健康的咨询平台', caseName: 'APP开发', type: 2, id: 6},
          {img: require('@/assets/images/case5.png'), title: '社保卡申领', describe: '政企社保卡申领小程序', caseName: 'APP开发', type: 2, id: 7},
          {img: require('@/assets/images/case10.png'), title: '雅致高定', describe: '高端人群定制圈，服装私人定制', caseName: 'APP开发', type: 2, id: 8},
          {img: require('@/assets/images/case4.png'), title: '智慧监控', describe: '嵌入式UPS智慧监控管理系统', caseName: '视觉设计', type: 3, id: 9},
          {img: require('@/assets/images/case11.png'), title: '直播室品牌物料', describe: '一家直播工作室的宣传物料', caseName: '视觉设计', type: 3, id: 10},
          {img: require('@/assets/images/case2.png'), title: '华润保健', describe: '华润集团旗下保健品宣传物料', caseName: '视觉设计', type: 3, id: 11},
          {img: require('@/assets/images/case1.png'), title: '51考拉', describe: '一个线上综合性考试平台', caseName: '视觉设计', type: 3, id: 12},
        ]
      };
    },
    created() {

    },
    methods: {
      onClickTab(item, index){
        console.log(item, index);
        this.activeTab = index
      }
    }
  };
  </script>
  
  <style scoped>
  .case{
    margin-bottom: 40px;
  }
  .case .title{
    text-align: center;
    padding-top: 50px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
  }
  .case .title span{
    font-size: 18px;
    line-height: 32px;
  }
  .case .title h3{
    line-height: 32px;
  }
  .case .title span img {
    margin-left: 5px; 
    vertical-align: middle;
    width: 15px;
    height: 15px;
  }
  .case .case-tab{
    display: flex;
    gap: 3px;
    padding-top: 50px;
  }
  .case .case-tab .tab-item{
    padding: 10px 20px;
    background: #f5f5f5;
    cursor: pointer;
    display: inline-flex;
  }
  .tab-item span{
    font-size: 18px;
  }
  .case .case-tab .active{
    background: #333333;
    color: #fff;
  }
  .case-box{
    padding: 20px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 15px; /* 使用gap属性设置间距 */
  }
  .case-item{
    width: calc(33.333% - 15px);  /* 或者使用 width: 33.333%; */
    box-sizing: border-box; /* 确保padding和border不会影响宽度计算 */
    border: 1px solid #dddddd;
  }
  .case-item .pic{
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .case-item .pic a{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    background: rgba(0, 0, 0, .5);
    display: none;
    transition: transform 0.3s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 18px;
    display: none;
  }
  .case-item:hover .pic a{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 18px;
  }
  .case-title{
    padding: 20px;
    border-top: none;
  }
  .case-item .pic img{
    display: flex;
    width: 100%;
    transition: transform 0.3s ease-in-out;
  }
  .case-item:hover .pic img{
    transform: scale(1.1);
  }
  .case-text{
    border-bottom: 1px solid #dddddd;
    padding-bottom: 15px;
  }
  .case-text h3{
    font-size: 18px;
    margin-bottom: 5px;
  }
  .case-text p{
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; 
  }
  .case-title .case-link{
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .case-title .case-link img{
    width: 30px;
    height: 10px;
  }
  .case-title .case-link p{
    font-size: 16px;
  }
  .case-more{
    text-align: center;
    margin-top: 20px;
  }
  .case-more a{
    display: inline-block;
    color: #000;
    border: 1px solid #313131;
    padding: 10px 20px;
    font-size: 18px;
  }

  .details-box{
    position: absolute;
    width: 100%;
    background: rgba(0, 0, 0, .8);
    top: 0;
    z-index: 999;
  }

  .details-box .content{
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: 80px 0;
    width: 50%;
  }

 
  </style>
  